<div class="gl-light:bg-primary z-10 bg-white shadow-md" [class.safe-top]="env.STATUS_BAR">
    <h2
        class="var-app-light-dark:font-bold orb-app-light-dark:font-bold mx-4 py-5 text-center text-base font-semibold"
        *ngIf="modalType === JourneyDirection.Origin">
        {{ 'CHOOSE_LOCATION_FROM_MAP_ORIGIN' | translate }}
    </h2>
    <h2
        class="var-app-light-dark:font-bold orb-app-light-dark:font-bold mx-4 py-5 text-center text-base font-semibold"
        *ngIf="modalType === JourneyDirection.Destination">
        {{ 'CHOOSE_LOCATION_FROM_MAP_DESTINATION' | translate }}
    </h2>

    <ion-button
        class="absolute right-0 top-0 m-0 my-0 h-16 w-16 text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
        [class.safe-top]="env.STATUS_BAR"
        [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
        (click)="cancel()"
        fill="clear">
        <span class="icon icon-input-delete text-[#5E5E5E] dark:text-contrast-yellow"></span>
    </ion-button>
    <mat-divider></mat-divider>
    <h2
        class="var-app-light-dark:text-sm var-app-light-dark:font-semibold orb-app-light-dark:font-semibold orb-app-light-dark:text-sm mx-4 py-4 text-base font-normal uppercase"
        [class.normal-case]="env.REMOVE_UPPERCASE">
        {{ 'MOVE_MAP_TO_SELECT_LOCATION' | translate }}
    </h2>
</div>

<ion-content>
    <rwidget-map
        [latitude]="mapCenter.latitude"
        [longitude]="mapCenter.longitude"
        (zoomChanged)="onZoomChanged($event)">
        <rwidget-map-layer-group *ngIf="formattedStops.length" [label]="'SCHEDULE_STOPS_LAYER' | translate">
            <rwidget-map-marker-group
                *ngIf="IconSizeOrderEnum[zoomIconSizeValue] >= IconSizeOrderEnum[stopsVisibleFromZoomSize]"
                [markers]="formattedStops"
                [iconZoomSize]="zoomIconSizeValue"
                [deleteOld]="true"
                (markerClicked)="onRouteStopClick($event)">
                <rwidget-map-icon
                    [forceContentClone]="true"
                    [preserveFill]="true"
                    [iconClass]="'text-secondary'"
                    [additionalClasses]="
                        'pn-app-light:text-grey-light pn-app-dark:text-black pn-light:text-grey-light pn-dark:text-black text-secondary varmland-light:text-grey-zambezy varmland-dark:text-black gl-light:text-grey-zambezy gl-dark:text-black orebro-dark:text-black hu-light:text-secondary hu-dark:text-contrast-yellow'
                    "
                    [url]="
                        zoomIconSizeValue === IconSizeEnum.small
                            ? (assetsPath$ | async) + '/leaflet/small_stop_icon.svg'
                            : iconStop
                    "
                    [size]="[getIconSize(MarkerType.stop), null]"
                    [anchor]="[getIconSize(MarkerType.stop) / 2, getIconSize(MarkerType.stop) / 2]"
                    [popupAnchor]="[0, -10]"></rwidget-map-icon>
                <rwidget-map-popup *ngIf="isShowPopup && zoomIconSizeValue !== IconSizeEnum.small">
                    <ng-container *ngTemplateOutlet="stopPopupTemplate"></ng-container>
                </rwidget-map-popup>
            </rwidget-map-marker-group>
            <!-- Favorite Stops -->
            <rwidget-map-marker-group
                [markers]="favoriteStops"
                [iconZoomSize]="zoomIconSizeValue"
                [deleteOld]="true"
                (markerClicked)="onRouteStopClick($event)">
                <rwidget-map-icon
                    [preserveFill]="true"
                    [iconClass]="'text-secondary'"
                    [url]="
                        (assetsPath$ | async) +
                        (zoomIconSizeValue === IconSizeEnum.small
                            ? '/leaflet/small_stop_icon.svg'
                            : '/img/explore/bus.svg')
                    "
                    [size]="[getIconSize(MarkerType.stopFavorite), null]"
                    [anchor]="[getIconSize(MarkerType.stopFavorite) / 2, getIconSize(MarkerType.stopFavorite) / 2]"
                    [popupAnchor]="[0, -10]"></rwidget-map-icon>
                <rwidget-map-popup *ngIf="isShowPopup && zoomIconSizeValue !== IconSizeEnum.small">
                    <ng-container *ngTemplateOutlet="stopPopupTemplate"></ng-container>
                </rwidget-map-popup>
            </rwidget-map-marker-group>
            <!-- Stops -->
            <ng-template #stopPopupTemplate>
                <div
                    class="flex cursor-pointer items-center gap-2 rounded-lg bg-white p-4 dark:bg-contrast-black dark:text-contrast-yellow"
                    (click)="clickOnBusStopInfo()">
                    <ion-icon
                        class="vl-app-light:text-black h-[1.375rem] w-[1.375rem] rounded text-white dark:text-contrast-yellow"
                        [src]="
                            (assetsPath$ | async) +
                            (env.EXPLORE?.USE_CONTRAST_ICON && (isContrast$ | async)
                                ? '/img/explore/bus-contrast.svg'
                                : 'img/explore/bus.svg')
                        "
                        aria-hidden="true"></ion-icon>
                    <p class="!m-0 flex-1 text-base">
                        {{ clickedStop?.name
                        }}<span *ngIf="clickedStop?.desc && env.JOURNEY_PLANNER?.SHOW_MUNICIPALITY_IN_STOP_NAME">
                            ({{ clickedStop.desc }})</span
                        >
                    </p>
                    <span class="vl-app-light:hidden">
                        <mat-icon>keyboard_arrow_right</mat-icon>
                    </span>
                    <ion-icon class="vl-app-light:block light hidden text-grey-zambezy" name="caret-forward"></ion-icon>
                </div>
            </ng-template>
        </rwidget-map-layer-group>

        <!-- Buses Layer -->
        <rwidget-map-layer-group
            *ngIf="env.JOURNEY_PLANNER?.SHOW_BUSES"
            [label]="'SCHEDULE_BUSES_LAYER' | translate"
            name="schedule-buses">
            <rwidget-map-marker
                *ngFor="let bus of busLocations$ | async"
                [latitude]="bus.latitude"
                [longitude]="bus.longitude">
                <rwidget-map-icon
                    [size]="[getIconSize(MarkerType.bus), getIconSize(MarkerType.bus)]"
                    [anchor]="[getIconSize(MarkerType.bus) / 2, getIconSize(MarkerType.bus) / 2]">
                    <rwidget-map-bus-icon [zoomSize]="zoomIconSizeValue" [bus]="bus"></rwidget-map-bus-icon>
                </rwidget-map-icon>
            </rwidget-map-marker>
        </rwidget-map-layer-group>

        <rwidget-map-locator></rwidget-map-locator>
    </rwidget-map>

    <ion-icon
        class="sr-app-light:hidden sr-app-light-dark:hidden gl-light-dark:hidden var-app-light:text-grey-zambezy orb-app-light:text-grey-zambezy absolute bottom-0 left-0 right-0 top-0 z-10 m-auto h-8 w-8 -translate-y-2/4 dark:text-contrast-black"
        [class.hidden]="env.APP_NAME === 'vastmanland-app'"
        alt=""
        src="{{ assetsPath$ | async }}/img/journey-planner/destination.svg"></ion-icon>
    <ion-button
        class="vl-app-light:bg-[#93C751] vl-app-light:rounded-lg vl-app-light:text-black var-app-light:text-black absolute bottom-8 left-4 right-4 z-10 dark:bg-contrast-yellow dark:text-contrast-black"
        [attr.aria-label]="'SET_LOCATION' | translate"
        (click)="confirm()"
        color="{{ locationButtonColor }}"
        size="large">
        <ion-label
            class="var-app-light-dark:font-semibold orb-app-light-dark:font-semibold text-base font-bold normal-case">
            {{ 'SET_LOCATION' | translate }}
        </ion-label>
    </ion-button>
</ion-content>
